export default __webpack_public_path__ + "static/media/background1.1332d73e.png";